module.exports = {
      id: "follow-instagram-usage",
      viewBox: "0 0 28 29",
      url: __webpack_public_path__ + "svg-sprite-9bf32fda02e4f885c0073d291388af8d.svg#follow-instagram",
      toString: function () {
        return this.url;
      }
    }